import React from 'react';
import { Checkbox } from '@atlaskit/checkbox';
import SectionMessage from '@atlaskit/section-message';
import { ChoiceQuestionStyles } from '../common/commonStyles';
import { ChoiceFieldWrapper, ChoicePlaceholder } from '../common/questionWrappers';
import { EditOtherOption } from './EditOtherOption';
export const EditMultiChoice = ({
  id,
  options,
  value,
  isInvalid,
  onChange,
  hasOtherOption,
  otherOptionSelected,
  otherOptionText,
  onOtherOptionTextChange,
  warningMessage
}) => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ChoiceFieldWrapper, {
    isDisabled: false,
    isInvalid: isInvalid
  }, /*#__PURE__*/React.createElement("div", null, options !== null && options !== void 0 && options.length ? /*#__PURE__*/React.createElement(ChoiceQuestionStyles, null, /*#__PURE__*/React.createElement("div", {
    id: id
  }, options.map(option => /*#__PURE__*/React.createElement(Checkbox, {
    name: id,
    key: option.value,
    value: option.value,
    label: option.label,
    isChecked: value === null || value === void 0 ? void 0 : value.includes(option),
    onChange: onChange
  })))) : /*#__PURE__*/React.createElement(ChoicePlaceholder, null), hasOtherOption && otherOptionSelected && /*#__PURE__*/React.createElement(EditOtherOption, {
    dropdown: false,
    value: otherOptionText,
    isDisabled: !otherOptionSelected,
    onChange: onOtherOptionTextChange
  }))), warningMessage && /*#__PURE__*/React.createElement(SectionMessage, {
    appearance: "warning"
  }, warningMessage));
};